export default __webpack_public_path__ + "static/media/csimg.70655c4e.png";